import type { SVGProps } from 'react';
export const IconStoresGooglePlay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.99614 5L17.148 15.2896L19.9313 12.448L7.62605 5.19443C7.42096 5.07291 7.20123 5.00561 6.99614 5ZM6.14649 5.47859C6.05493 5.64497 6 5.84126 6 6.06186V26.0578C6 26.2186 6.03296 26.3625 6.08789 26.4915L16.4741 15.9626L6.14649 5.47859ZM20.7809 12.9415L17.8072 15.9626L20.7809 18.9687L24.4139 16.845C24.9303 16.5403 25.0035 16.1533 24.9999 15.9477C24.9944 15.6074 24.7838 15.2896 24.4286 15.0952C24.1191 14.9251 21.821 13.5585 20.7809 12.9415ZM17.148 16.6356L6.90824 27C7.07854 26.9907 7.26348 26.9533 7.43561 26.8504C7.83663 26.613 15.9467 21.8253 15.9467 21.8253L19.9459 19.4772L17.148 16.6356Z"
      fill="currentColor"
    />
  </svg>
);
